
const LoadingDefaultComponent = () => (
  <div>Đang tải.....</div>
);

export default LoadingDefaultComponent;
